var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstronautaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_12735",
    "data-name": "Grupo 12735",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.5,
    height: 32.666,
    viewBox: "0 0 31.5 32.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4259",
    "data-name": "Rect\\xE1ngulo 4259",
    width: 31.5,
    height: 32.666,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12246",
    "data-name": "Grupo 12246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_819",
    "data-name": "Trazado 819",
    d: "M30.99,17.192a2.926,2.926,0,0,0-1.943-1.241l-4.078-.535A8.6,8.6,0,0,0,28,8.944C28,4.012,23.638,0,18.277,0A9.883,9.883,0,0,0,9.742,4.667H8.558A2.339,2.339,0,0,0,6.222,7v5.185l-.993-.17a2.81,2.81,0,0,0-1.072,5.515l2.065.45v.681A2.339,2.339,0,0,0,8.558,21h2.41l-3.882,4.27L4.66,24.533,1.321,24.5A1.322,1.322,0,0,0,0,25.819v5.526a1.322,1.322,0,0,0,1.321,1.321h.113a3.234,3.234,0,0,0,3.141-2.5A9.817,9.817,0,0,0,8.9,31.418a4.076,4.076,0,0,0,1.669-.324,5.248,5.248,0,0,0,1.417.94,4.1,4.1,0,0,0,1.637.338,4.489,4.489,0,0,0,3.006-1.183c.8-.725,2.242-2.059,2.976-2.858a26.217,26.217,0,0,0,3.759-6.553h5.2a2.933,2.933,0,0,0,2.424-4.585",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_820",
    "data-name": "Trazado 820",
    d: "M23.4,25.271a1.324,1.324,0,0,1-.1.517,25.72,25.72,0,0,1-3.5,6.179c-.694.755-2.1,2.053-2.878,2.759a2.794,2.794,0,0,1-2.976.57,3.6,3.6,0,0,1-.779-.495l3.5-3.552a.778.778,0,0,0-1.108-1.092l-3.922,3.977c-.013.015-1.348,1.35-5.486-.9A.729.729,0,0,0,6,33.187V30.85l1.3.394a.764.764,0,0,0,.66,1.157.775.775,0,0,0,.576-.254L13.67,26.5a2.343,2.343,0,0,0,.612-1.582V21.1a10.244,10.244,0,0,0,5.328,1.478A10.39,10.39,0,0,0,23.4,21.87Z",
    transform: "translate(-1.333 -4.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_821",
    "data-name": "Trazado 821",
    d: "M21.166,16.777c-4.5,0-8.166-3.315-8.166-7.389S16.663,2,21.166,2s8.166,3.315,8.166,7.389-3.663,7.389-8.166,7.389",
    transform: "translate(-2.889 -0.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_822",
    "data-name": "Trazado 822",
    d: "M14.778,13.6A.778.778,0,0,1,14,12.824V10.778a.778.778,0,1,1,1.556,0v2.046a.778.778,0,0,1-.778.778",
    transform: "translate(-3.111 -2.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_823",
    "data-name": "Trazado 823",
    d: "M23.225,28.667H19.774A1.776,1.776,0,0,1,18,26.892V25.774A1.776,1.776,0,0,1,19.774,24h3.451A1.776,1.776,0,0,1,25,25.774v1.118a1.776,1.776,0,0,1-1.775,1.774m-3.451-3.111a.219.219,0,0,0-.219.219v1.118a.219.219,0,0,0,.219.219h3.451a.219.219,0,0,0,.219-.219V25.774a.219.219,0,0,0-.219-.219Z",
    transform: "translate(-4 -5.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_824",
    "data-name": "Trazado 824",
    d: "M23.111,3a6.611,6.611,0,1,0,6.611,6.611A6.618,6.618,0,0,0,23.111,3m0,11.666a5.057,5.057,0,0,1-4.537-2.84A4.961,4.961,0,0,1,23.5,8.444c2.612,0,4,1.046,4.239,3.2a5.062,5.062,0,0,1-4.628,3.027M23.5,6.889a6.881,6.881,0,0,0-5.433,2.5,5.051,5.051,0,0,1,9.992-.809A5.887,5.887,0,0,0,23.5,6.889",
    transform: "translate(-3.667 -0.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_825",
    "data-name": "Trazado 825",
    d: "M3.556,36.878A1.679,1.679,0,0,1,2,38.551V33.5H3.556Z",
    transform: "translate(-0.444 -7.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_826",
    "data-name": "Trazado 826",
    d: "M14.226,19.669v1.9L12.745,18.51l.784.135a9.49,9.49,0,0,0,.75.762.771.771,0,0,0-.053.262",
    transform: "translate(-2.832 -4.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_827",
    "data-name": "Trazado 827",
    d: "M10,8.781A.781.781,0,0,1,10.781,8h.46a8.209,8.209,0,0,0,.471,6.524L10,14.231Z",
    transform: "translate(-2.222 -1.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_828",
    "data-name": "Trazado 828",
    d: "M5.489,19.88a1.255,1.255,0,0,1,.478-2.463l3.063.524,1.464,3.029Z",
    transform: "translate(-1 -3.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_829",
    "data-name": "Trazado 829",
    d: "M10.781,24.679A.781.781,0,0,1,10,23.9v-.342l3.617.787v.336Z",
    transform: "translate(-2.222 -5.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_830",
    "data-name": "Trazado 830",
    d: "M30.372,24.83V21.612l1.388.181Z",
    transform: "translate(-6.75 -4.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_831",
    "data-name": "Trazado 831",
    d: "M37.13,24.03a1.382,1.382,0,0,1-1.351,1.108H32.456l1.38-3.02,2.186.287A1.377,1.377,0,0,1,37.13,24.03",
    transform: "translate(-7.213 -4.915)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronautaIcon);
export default __webpack_public_path__ + "static/media/astronautaIcon.7445703738d272604b66d5f4dff271f9.svg";
export { ForwardRef as ReactComponent };